import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SurfingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"surfing"}/>
}
